import axios from 'axios'
import routesConfig from 'routesConfig';

const instanceAxios = axios.create({
    headers: {
        'X-Api-Key': 'valor del key de base de datos'
    },
    baseURL: routesConfig.apiPortal + 'api/'
});

export default instanceAxios